import { env } from '../env';

export const getCountries = callback => {
  env.http.get('countries').then(data => {
    const response = data.data;
    return callback(response);
  });
};

export const getBanks = (id, callback) => {
  env.http.get(`banks/${id}`).then(data => {
    const response = data.data;
    return callback(response);
  });
};

export const getTypePayment = (id, callback) => {
  env.http.get(`payment-methods/${id}`).then(data => {
    const response = data.data;
    return callback(response);
  });
};
